import React, { useEffect, useState } from 'react';
import { Auth, Services, Stats, api as call } from '../utils/api';

/**
 * AdminHome
 * - Lấy thông tin người dùng đang đăng nhập
 * - Lấy meta site, danh sách dịch vụ và thống kê
 * - Cho phép đăng xuất
 */
export default function AdminHome() {
    const [me, setMe] = useState(null);
    const [meta, setMeta] = useState(null);
    const [services, setServices] = useState([]);
    const [stats, setStats] = useState([]);

    useEffect(() => {
        let alive = true;

        (async () => {
            try {
                const d = await Auth.me();
                if (alive) setMe(d?.user || null);
            } catch (_) { }

            try {
                const m = await call('/meta/site');
                if (alive) setMeta(m || null);
            } catch (_) { }

            try {
                const list = await Services.list();
                const items = Array.isArray(list) ? list : list?.items;
                if (alive) setServices(items || []);
            } catch (_) { }

            try {
                const s = await Stats.overview();
                const items = Array.isArray(s) ? s : s?.items;
                if (alive) setStats(items || []);
            } catch (_) { }
        })();

        return () => {
            alive = false;
        };
    }, []);

    async function doLogout() {
        try {
            await Auth.logout();            // <— dùng Auth cho thống nhất & tránh “api is not defined”
        } finally {
            window.location.replace('/login');
        }
    }

    return (
        <div style={{ padding: 16, maxWidth: 980, margin: '0 auto' }}>
            <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h2 style={{ margin: 0 }}>Admin dashboard</h2>
                <div>
                    {me && (
                        <span style={{ marginRight: 12, opacity: 0.8 }}>
                            {me.username}{me.role ? ` (${me.role})` : ''}
                        </span>
                    )}
                    <button onClick={doLogout}>Đăng xuất</button>
                </div>
            </header>

            <section style={{ marginTop: 16 }}>
                <h3>Meta</h3>
                <pre style={{ background: '#f6f7f8', padding: 12, borderRadius: 8, overflow: 'auto' }}>
                    {JSON.stringify(meta, null, 2)}
                </pre>
            </section>

            <section style={{ marginTop: 16 }}>
                <h3>Services</h3>
                <pre style={{ background: '#f6f7f8', padding: 12, borderRadius: 8, overflow: 'auto' }}>
                    {JSON.stringify(services, null, 2)}
                </pre>
            </section>

            <section style={{ marginTop: 16 }}>
                <h3>Stats (overview)</h3>
                <pre style={{ background: '#f6f7f8', padding: 12, borderRadius: 8, overflow: 'auto' }}>
                    {JSON.stringify(stats, null, 2)}
                </pre>
            </section>
        </div>
    );
}
